<div class="tidy-dropdown-menu">
  <button class="dropdown-trigger" (click)="toggle()">
    <span class="trigger-text">{{ displayText }}</span>
    <span class="material-icons trigger-icon">{{ triggerIcon }}</span>
  </button>
  @if (isOpen) {
    <div class="dropdown-panel">
      @for (item of items; track item.value) {
        <button class="dropdown-option" (click)="onSelectItem(item)">
          @if (item.icon) {
            <span class="material-icons option-icon">{{ item.icon }}</span>
          }
          <span class="option-label">{{ item.label }}</span>
          @if (showCheckmarks && selectedValue === item.value) {
            <span class="material-icons check-icon">check</span>
          }
        </button>
      }
      <ng-content select="[footer]" />
    </div>
  }
</div>
